import eagleEyes from '@/assets/logos/eagle-eyes.png';
import olaparty from '@/assets/logos/olaparty.png';
import trumeet from '@/assets/logos/trumeet.png';

export const BRAND_LOGO = eagleEyes;

export const PLATFORM_LOGOS = {
    olaparty,
    trumeet,
};

export function platformLogo(key) {
    return PLATFORM_LOGOS[(key || '').toLowerCase()] || null;
}
